<div class="container">
  <div *ngIf="isLoading" class="row center">
    <div class="spinner-border text-danger" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div *ngIf="!isLoading" class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
      <div class="col-md-12 col-xs-12 mgb-10">
        <h2>All Active Events</h2>
      </div>
      <div class="col-md-12 col-xs-12 mgb-10">
        <h3>Tennis / Soccer</h3>
      </div>
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th class="center pd1p">#</th>
                <th>MKT ID</th>
                <th>Event ID</th>
                <th>Event Name</th>
                <th>Sport Name</th>
                <th>Odds Source</th>
                <!--th>Fancy Source</th-->
                <!--th>Score</th-->
                <th>Open Date</th>
                <th>Action</th>
                <!-- <th *ngIf="level == '1'">Set Limit</th> -->
                <th *ngIf="level == '1'">Result</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of match; let i = index">
                <td class="center pd1p">{{ i+1 }}</td>
                <td>{{ data.marketId }}</td>
                <td>{{ data.eventId }}</td>
                <td>{{ data.eventName }}</td>
                <td><span class="badge badgeback">{{ data.sportName }}</span></td>
                <td *ngIf="data.oddsProvider == 'neeraj'"><span class="badge badgeback">{{ 'Betfair' | uppercase
                    }}</span>
                </td>
                <td *ngIf="data.oddsProvider != 'neeraj'"><span class="badge badgeback">{{ data.oddsProvider | uppercase
                    }}</span>
                </td>
                <!--td>
                  <select class="w100" id="odds{{ i }}">
                    <option value="">Select</option>
                    <option [selected]="data.oddsProvider == 'diamond'" value='diamond'>Diamond</option>
                    <option [selected]="data.oddsProvider == 'neeraj'" value='neeraj'>Neeraj</option>
                    <option [selected]="data.oddsProvider == 'sky'" value='sky'>Sky</option>
                  </select>
                  <br>
                  <button id="obtn{{ i }}" (click)="updateOdds(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Odds</button>
                  <div id="oprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="oerror{{ i }}">Please Select Odds First</span>
                </td-->
                <!--td>
                  <select class="w100" id="fancy{{ i }}">
                    <option value="">Select</option>
                    <option [selected]="data.fancyProvider == 'diamond'" value='diamond'>Diamond</option>
                    <option [selected]="data.fancyProvider == 'neeraj'" value='neeraj'>Neeraj</option>
                    <option [selected]="data.fancyProvider == 'sky'" value='sky'>Sky</option>
                  </select>
                  <br>
                  <button id="fbtn{{ i }}" (click)="updateFancy(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Fancy</button>
                  <div id="fprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="ferror{{ i }}">Please Select Fancy First</span>
                </td-->
                <!--td *ngIf="isScore">
                  <select class="w100" id="score{{ i }}">
                    <option value="">Select</option>
                    <option *ngFor="let score3 of scoreList3" [selected]="score3.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score3.matchname }}", "cricexchageid": "{{ score3.cricexchageid }}"}'>
                      {{ score3.matchname}}</option>
                    <option *ngFor="let score1 of scoreList1" [selected]="score1.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score1.matchname }}", "cricexchageid": "{{ score1.cricexchageid }}"}'>
                      {{ score1.matchname}}</option>
                    <option *ngFor="let score2 of scoreList2" [selected]="score2.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score2.matchname }}", "cricexchageid": "{{ score2.cricexchageid }}"}'>
                      {{ score2.matchname}}</option>
                      <option *ngFor="let score4 of scoreList4" [selected]="score4.cricexchageid == data.scoreId"
                      value='{"liveline": "{{ score4.matchname }}", "cricexchageid": "{{ score4.cricexchageid }}"}'>
                      {{ score4.matchname}}</option>
                  </select>
                  <br>
                  <button id="btn{{ i }}" (click)="updateScore(i, data.eventId)"
                    class="btn btn-s-md btn-info uscore">Update Score</button>
                  <div id="process{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="error{{ i }}">Please Select Match First</span>
                </td-->
                <!--td *ngIf="!isScore">
                  <div class="spinner-border2 text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </td-->
                <td>{{ data.openDate }}</td>
                <td><a routerLink="/fancy/{{ data.eventId }}"><button class="btn btn-danger fbtn">Get Fancy</button></a>
                </td>
                <!-- <td *ngIf="level == '1'"><a routerLink="/setLimit/{{ data.eventId }}/{{ data.sportId }}"><button
                      class="btn btn-warning fbtn">Set Limit</button></a>
                </td> -->
                <!--td>
                  <select class="w100" id="result{{ i }}">
                    <option value="">Select</option>
                    <option value='{ "id": "98765", "name": "No Result" }'>No Result</option>
                    <option *ngFor="let runners of data.matchRunners"
                      value='{ "id": "{{ runners.selectionId }}", "name": "{{ runners.name }}" }'>{{ runners.name }}
                    </option>
                  </select>

                  <button id="rbtn{{ i }}" (click)="setResult(i, data.eventId, data.eventName)"
                    class="btn btn-s-md btn-info uscore">Set Result</button>
                  <div id="rprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <span class="error" id="rerror{{ i }}">Please Select Selection First</span>
                </td-->
                <td *ngIf="level == '1'">
                  <button id="mbtn{{ i }}" (click)="removeMatch(i, data.eventId)" class="btn btn-primary">
                    Remove Match
                  </button>
                  <button id="mdbtn{{ i }}" (click)="deleteMatch(i, data.eventId)" class="btn btn-danger">
                    Delete Match
                  </button>
                  <div id="mprocess{{ i }}" class="row center" style="margin-top:5px;display:none;">
                    <div class="spinner-border2 text-danger" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>